import { Button, Container } from 'react-bootstrap';
import Banner from '../../Component/Banner';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get, ref, set } from 'firebase/database';

import { db } from '../../ReactNative/firebase';

const PrimTrivia = () => {
    const [question, setQuestion] = useState(0)
    const [startTime] = useState(() => Date.now());
    const navigate = useNavigate()
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [userAnswers, setUserAnswers] = useState(
        [
            {
                id: 0,
                answer: ''
            },
            {
                id: 1,
                answer: ''
            },
            {
                id: 2,
                answer: ''
            },
            {
                id: 3,
                answer: ''
            },
            {
                id: 4,
                answer: ''
            },
            {
                id: 5,
                answer: ''
            },
            {
                id: 6,
                answer: ''
            },
            {
                id: 7,
                answer: ''
            },
            {
                id: 8,
                answer: ''
            },
            {
                id: 9,
                answer: ''
            }
        ]
    )

    const answerArray = useMemo(() => [
        'Primrose Eleanor Haukea Radin',
        'June 14, 2019',
        'Kailua, Hawaii',
        'Artist',
        'Shadow Valley Elementary',
        'Painting',
        'Noodles and mac ‘n cheese',
        'Chikachik',
        'Purple',
        'Night Begins To Shine by B.E.R.',
    ], [])
    
    var questionArray = [
        "What is Primrose’s full name?",
        'When is Primrose’s birthday?',
        "Where was she born?",
        "What does she currently want to be when she grows up?",
        "She just finished first grade in Ogden, Utah, what is the school name?",
        "She recently placed 4th in a contest. What is the category?",
        "What are her top 2 favorite foods?",
        'What is her nickname?',
        "What is her favorite color?",
        "What is her favorite song?"
    ]

    var choicesArray = [
        [
            'Primrose Eleanor Abuan Radin',
            'Primrose Eleanor Haukea Radin',
            'Primrose Eleanor Herman Radin',
            'Primrose Eleanor Urim Radin',
        ],
        [
            'June 12, 2019',
            'June 13, 2019',
            'June 14, 2019',
            'June 15, 2019',
        ],
        [
            'San Fernando, La Union',
            'Salt Lake City, Utah',
            'Kailua, Hawaii',
            'Laie, Hawaii',
        ],
        [
            'Artist',
            'Astronaut',
            'Doctor',
            'Firefighter',
        ],
        [
            'Bonneville Elementary',
            'James Madison Elementary',
            'Shadow Valley Elementary',
            'Uintah Elementary',
        ],
        [
            'Singing',
            'Dancing',
            'Painting',
            'Poetry',
        ],
        [
            'Noodles and mac ‘n cheese',
            'Sandwich and Fries',
            'Burger and mashed potatoes',
            'Fried chicken and hotdog',
        ],
        [
            'Babot',
            'Chikachik',
            'Ellie',
            'Hauhau',
        ],
        [
            'Blue',
            'Red',
            'Green',
            'Purple',
        ],
        [
            'From the Start by Laufey',
            'Night Begins To Shine by B.E.R.',
            'One More Time by Daft Punk',
            'Home by Charlie Puth',
        ]
    ]

    const finishQuiz = () => {
        const endTime = Date.now();
        const timeTaken = Math.floor((endTime - startTime) / 1000);
    
        let userScore = 0;
    
        for (let i = 0; i < answerArray.length; i++) {
            if (answerArray[i] === userAnswers[i].answer) {
                userScore++;
            }
        }
    
        sessionStorage.setItem('PrimTriviaScore', userScore);
        sessionStorage.setItem('PrimTriviaTime', timeTaken);
    
        get(ref(db, 'PrimTriviaScoreboard/')).then((snap) => {
            const theNewValue = [];
        
            const data = Object.values(snap.val() || {});
        
            data.forEach(item => {
                theNewValue.push(item);
            });
        
            theNewValue.push({
                email: sessionStorage.getItem('PrimTriviaEmail'),
                name: sessionStorage.getItem('PrimTriviaName'),
                score: userScore,
                time: timeTaken
            });
        
            set(ref(db,'PrimTriviaScoreboard/'), theNewValue);
        });
    
        navigate('/QuizTrivias/June2026/primend');
    }

    useEffect(() => {
        if (question === 0) {
            window.scrollTo(0, 0);
        }
    
        const score = sessionStorage.getItem('PrimTriviaScore');
        const started = sessionStorage.getItem('PrimTriviaStarted');
        const email = sessionStorage.getItem('PrimTriviaEmail');
    
        if (score) {
            alert("Looks like you've already taken the quiz. Thanks for participating!");
            navigate('/QuizTrivias/June2026/primend');
            return;
        }
    
        if (!started) {
            alert("Please start the quiz properly.");
            navigate('/QuizTrivias/June2026/prim');
            return;
        }
    
        if (!email) {
            alert("Seems like you haven't added your info. Please do so first.");
            navigate('/QuizTrivias/June2026/prim');
            return;
        }
    }, [navigate, question]);
    
    useEffect(() => {
        const interval = setInterval(() => {
            setElapsedTime(
                Math.floor((Date.now() - startTime) / 1000)
            );
        }, 1000);
    
        return () => clearInterval(interval);
    }, [startTime]);

    const isAnswered = !!userAnswers[question]?.answer;
    function showChoices() {
        const options = choicesArray[question];
    
        function handleSelect(index) {
            const updated = userAnswers.map((a, i) => {
                if (i === question) {
                    return {
                        ...a,
                        answer: options[index]
                    };
                }
                return a;
            });
    
            setUserAnswers(updated);
            setSelectedIndex(index);
        }
    
        return (
            <div className="buttonToEdit">
                {options.map((opt, i) => (
                    <div key={i}>
                        <Button
                            onClick={() => handleSelect(i)}
                            className={`ybtnSizeUp ${selectedIndex === i ? "ybtn-success" : ""}`}
                        >
                            {opt}
                        </Button>
                        <br /><br />
                    </div>
                ))}
            </div>
        );
    }
    const progressText = `Question ${question + 1} / ${questionArray.length}`;
    const minutes = Math.floor(elapsedTime / 60);
    const seconds = elapsedTime % 60;

    const timerText = `${minutes}:${seconds
        .toString()
        .padStart(2, '0')}`;
    return (
        <>
            <Container className="keiki-party prim-7th">

                <Banner caption=""/>
            <div className='text-center'>
                <div className='Apps'>
                    <br />
                    <h3 className="fontBackground Trivia-Timer">
                    ⏱ {timerText}
                </h3>
                <h4 className="fontBackground">{progressText}</h4>
                    <h2 className='fontBackground'>{questionArray[question]}</h2>
                    {showChoices()}
                    <br />
                    <Button
                        disabled={!isAnswered}
                        onClick={() => {
                            if (!isAnswered) {
                                alert("Please select an answer first!");
                                return;
                            }

                            if (question < questionArray.length - 1) {
                                setQuestion(q => q + 1);
                                setSelectedIndex(null);
                            } else {
                                finishQuiz();
                            }
                        }}
                        className="prim-next-btn"
                    >
                        {question === questionArray.length - 1 ? "Finish" : "Next"}
                    </Button>
                </div>
            </div>
            </Container>
        </>
    )
}

export default PrimTrivia;